import type React from 'react'
import type { IconProps } from './types'

const Release: React.FC<IconProps> = ({ size = 20, className = 'fill-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M3 20V4L22 12L3 20ZM5 17L16.85 12L5 7V10.5L11 12L5 13.5V17Z' />
	</svg>
)

export default Release
